import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

export interface IWarrantyError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IWarrantyError = {
  hasFailed: false,
  message: ''
};

const warrantyProviders = (
  state: IInitialState['warranty']['warrantyProviders'] = INITIAL_STATE.warranty
    .warrantyProviders || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_WARRANTY_PROVIDERS: {
      return payload;
    }
    default:
      return state;
  }
};

const warrantyChecks = (
  state: IInitialState['warranty']['warrantyChecks'] = INITIAL_STATE.warranty
    .warrantyChecks || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_WARRANTY_CHECKS: {
      return payload;
    }
    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IWarrantyError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

export default combineReducers({
  warrantyProviders,
  warrantyChecks,
  isPending,
  error
});
